import CookieHandler from '../../infrastructure/adapter/CookieHandler';
import HttpClient from '../../infrastructure/adapter/HttpClient';
import BrowserHistoryHandler from '../../infrastructure/adapter/BrowserHistoryHandler';

abstract class Repository {
  protected httpClient: HttpClient;
  protected cookieHandler: CookieHandler;
  protected browserHistoryHandler: BrowserHistoryHandler;
  constructor({
    httpClient,
    cookieHandler,
    browserHistoryHandler,
  }: {
    httpClient: HttpClient;
    cookieHandler: CookieHandler;
    browserHistoryHandler: BrowserHistoryHandler;
  }) {
    this.httpClient = httpClient;
    this.cookieHandler = cookieHandler;
    this.browserHistoryHandler = browserHistoryHandler;
  }
}

export default Repository;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/domain/repository/BaseRepository.ts